import { useEffect, useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";
import MapsHomeWorkTwoToneIcon from "@mui/icons-material/MapsHomeWorkTwoTone";
import RealEstateAgentTwoToneIcon from "@mui/icons-material/RealEstateAgentTwoTone";
import SupervisorAccountTwoToneIcon from "@mui/icons-material/SupervisorAccountTwoTone";
import RestoreIcon from '@mui/icons-material/Restore';
import CorretorAba from "./SubAbas/Corretor/CorretorAba";
import GerenteAba from "./SubAbas/Gerente/GerenteAba";
import ImobiliariaAba from "./SubAbas/Imobiliaria/ImobiliariaAba"
import HistoricoAlteracoesAba from "./SubAbas/HistoricoAlteracoes/HistoricoAlteracoesAba"

const tabConfig = [
  { id: "corretores", label: "Corretores", icon: <RealEstateAgentTwoToneIcon fontSize="small" /> },
  { id: "gerentes", label: "Gerentes", icon: <SupervisorAccountTwoToneIcon fontSize="small" /> },
  { id: "imobiliarias", label: "Imobiliárias", icon: <MapsHomeWorkTwoToneIcon fontSize="small" /> },
  { id: "historico", label: "Histórico de Alterações", icon: <RestoreIcon fontSize="small" /> },
];

const AssistenteVendasGestao = ({ onContactClick = () => {} }) => {
  const [tabAtiva, setTabAtiva] = useState(0);
  const tabsDisponiveis = tabConfig;

  useEffect(() => {
    if (tabAtiva >= tabsDisponiveis.length) {
      setTabAtiva(0);
    }
  }, [tabAtiva, tabsDisponiveis.length]);

  const handleTabChange = (_event, novaTab) => {
    setTabAtiva(novaTab);
  };

  const renderTabContent = () => {
    const activeTabId = tabsDisponiveis[tabAtiva]?.id;

    switch (activeTabId) {
      case "corretores":
        return <CorretorAba onContactClick={onContactClick} />;
      case "gerentes":
        return <GerenteAba onContactClick={onContactClick} />;
      case "imobiliarias":
        return <ImobiliariaAba />;
      case "historico":
        return <HistoricoAlteracoesAba />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      <Paper elevation={1} sx={{ borderRadius: 2, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
        <Tabs
          value={tabAtiva}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: "1px solid",
            borderColor: "divider",
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: { xs: "0.8rem", sm: "0.9rem" },
              fontWeight: 500,
              minWidth: { xs: 100, sm: 140 },
              py: 2,
              "& .MuiTab-iconWrapper": {
                marginBottom: "4px !important",
              },
            },
          }}
        >
          {tabsDisponiveis.map((tab) => (
            <Tab key={tab.id} icon={tab.icon} label={tab.label} />
          ))}
        </Tabs>

        <Box sx={{ p: 3, bgcolor: 'background.paper', color: 'text.primary' }}>
          {renderTabContent()}
        </Box>
      </Paper>
    </Box>
  );
};

export default AssistenteVendasGestao;
